export const getPossibleValues = (styleSetting) => {
    if (styleSetting.name === "mode") {
        const modes = styleSetting.possibleValues.find(
            (obj) => obj.key === styleSetting.key
        ).values
        return modes
    }

    if (styleSetting.name.startsWith("track")) {
        const instruments = styleSetting.possibleValues.flatMap(category => category.instrument);
        return instruments;
    }

    return styleSetting.possibleValues
}
